module.exports = __webpack_public_path__ + "static/media/icn-trouvez.b17db40b.svg";